import React from "react";
import cx from "classnames";
import { Text } from "../Type";

import styles from "./index.module.scss";

type PropsType = {
  activePig?: boolean;
  small?: boolean;
  count: number;
  className?: string;
};

// const threeSeconds = 3000;

const PigRunCount = ({ count, className, small }: PropsType) => {
  // const [bounce, setBounce] = React.useState(false);
  // React.useEffect(() => {
  //   if (activePig) {
  //     setBounce(true);
  //   } else {
  //     setTimeout(() => setBounce(false), threeSeconds);
  //   }
  // }, [activePig]);

  return (
    <Text
      size={small ? "small" : "regular"}
      className={cx(styles.LinkIconCount, className)}
    >
      {count}
    </Text>
  );
};

export default PigRunCount;
